import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from 'src/app/core/layouts/dashboard/dashboard.component';
import { ReasonListContainerComponent } from './reason-list-container/reason-list-container.component';

const routes: Routes = [  {
  path: '',
  component: DashboardComponent,
  children: [
    {path: '', component: ReasonListContainerComponent}
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReasonsRoutingModule { }
